import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Copper Pipes & Fittings',
    image: '/images/plumbers-heating/plumber-copper-pipes.png',
  },
  {
    title: 'Radiators',
    image: '/images/plumbers-heating/plumber-radiators.png',
  },
  {
    title: 'Boilers & Tanks',
    image: '/images/plumbers-heating/plumber-boilers-tanks.png',
  },
  {
    title: 'Valves & Metal Parts',
    image: '/images/plumbers-heating/plumber-valves-parts.png',
  },
  {
    title: 'Pipe Offcuts',
    image: '/images/plumbers-heating/plumber-pipe-offcuts.png',
  },
  {
    title: 'Cylinders & Heating Hardware',
    image: '/images/plumbers-heating/plumber-cylinders-hardware.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your postcode and what needs clearing from the plumbing or heating job.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a convenient collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing so pickup fits around your site work.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Copper, radiators and heating metal leave the job through licensed routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your team stays on installs and repairs while the leftovers are cleared.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep boiler swaps and pipework strip-outs tidy with accountable collections.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing half a day hauling radiators yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Copper and steel are recovered for reuse instead of mixed waste streams.',
  },
  {
    title: 'Built for trade callouts',
    body: 'Share access notes and photos so collectors arrive ready for heating scrap.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear job leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Copper recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function PlumbersHeatingPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="ph-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="ph-hero-heading">
              Scrap collection for <span>plumbers & heating engineers</span>
            </h1>
            <p className="kf-lead">
              Clear copper, radiators, boilers and heating leftovers quickly and responsibly — so
              your next install or repair stays tidy and on schedule.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-plumbers-heating.png"
              alt="Plumbing and heating scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for plumbing & heating crews — copper, radiators, boilers and offcuts
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="ph-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="ph-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from plumbing installs, boiler swaps and heating jobs</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="ph-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="ph-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clear job site</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="ph-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="ph-why-heading">Why plumbers & heating engineers choose SnapScrap</h2>
            <p>Clear space, keep callouts moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your plumbing & heating scrap for free today</h2>
            <p>
              List leftovers from your next boiler swap or pipework job and get matched with a
              licensed collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
